import logoIcon from '@/assets/img/logo-icon.svg';

export default function Loading() {
    return (
        <div className="overlay">
            <div className="text-center">
                <img src={logoIcon} alt="FurtherPass" />
            </div>
        </div>
    )
}